module.exports = __webpack_public_path__ + "img/arraw_r.18206725.svg";